import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M264 315L445 496L264 677L319 732L500 551L681 732L736 677L555 496L736 315L681 260L500 441L319 260ZM0 498C0 830 190 1000 500 1000C810 1000 1000 830 1000 498C1000 191 810 0 500 0C190 0 0 191 0 498ZM82 558V438C82 235 260 74 500 74C740 74 918 235 918 438V558C918 771 764 926 500 926C236 926 82 771 82 558Z" })
});
export default SvgErrorIcon;
